module.exports = __webpack_public_path__ + "static/media/lockscreen.eb4633cc.jpg";